import { render, staticRenderFns } from "./VideoEvaluationView.vue?vue&type=template&id=a1a659dc&"
import script from "./VideoEvaluationView.vue?vue&type=script&lang=js&"
export * from "./VideoEvaluationView.vue?vue&type=script&lang=js&"
import style0 from "./VideoEvaluationView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports